module.exports = __webpack_public_path__ + "img/logo_dkd.9707ef01.png";